import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  FiltersRangeDto,
  InterventionReportSummary,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.repairer}interventionreports/search`;

export enum ReverseCommonModelWorkflowClosingType {
  NONE = 'NONE',
  REPAIRED_WITHOUT_SPARE_PART = 'REPAIRED_WITHOUT_SPARE_PART',
  REPAIRED_WITH_SPARE_PART = 'REPAIRED_WITH_SPARE_PART',
  QUOTE_REFUSED_DEVICE_ABANDONED = 'QUOTE_REFUSED_DEVICE_ABANDONED',
  QUOTE_REFUSED_DEVICE_RETURNED = 'QUOTE_REFUSED_DEVICE_RETURNED',
  REPAIR_REJECTED = 'REPAIR_REJECTED',
  SWAPPED_BY_SUPPLIER = 'SWAPPED_BY_SUPPLIER',
  NO_FAILURE_NOTED = 'NO_FAILURE_NOTED',
  FILE_CANCELLED = 'FILE_CANCELLED',
  TAKEN_BACK = 'TAKEN_BACK',
  OPTIONAL_REPAIR = 'OPTIONAL_REPAIR',
  PHONE_RESOLVED = 'PHONE_RESOLVED',
  RESTORED_WITHOUT_ACTION = 'RESTORED_WITHOUT_ACTION',
  QUOTE_REFUSED = 'QUOTE_REFUSED',
  SOFTWARE_UPDATE = 'SOFTWARE_UPDATE',
}

export interface FacetDto {
  name?: string;
  label?: string;
  included?: boolean;
  count?: number;
  key?: string;
}

export type RubricDefaultDto = {
  name: string;
  type: RUBRIC_TYPES.DEFAULT | RUBRIC_TYPES.NUMERIC;
  isTranslatable: boolean;
  facets: FacetDto[];
};

export enum ViewableColumnType {
  TEXT = 'Text',
  DATE = 'Date',
  ARRAY = 'Array',
  MONEY = 'Money',
}
export enum ViewableColumnSubType {
  DATETIME = 'DateTime',
  ELAPSED = 'Elapsed',
  TITLE = 'Title',
  PHONE_NUMBER = 'PhoneNumber',
  TAG = 'Tag',
  ENUM = 'Enum',
}

export interface ViewableColumn {
  key: string;
  columnType: ViewableColumnType;
  columnSubType: ViewableColumnSubType;
  children?: ViewableColumn[];
  isSortable: boolean;
}

export interface InterventionReportDto {
  rubrics: RubricDefaultDto[];
  hitCount: number;
  hits: InterventionReportSummary[];
  sortableProperties: string[];
  viewableColumns: ViewableColumn[];
}

export enum RUBRIC_TYPES {
  DEFAULT = 'default',
  DATE = 'date',
  RANGE_NUMERIC = 'rangeNumeric',
  NUMERIC = 'numeric',
  PERCENTAGE = 'percentage',
}

interface SearchInterventionReportsCommandPayload {
  query: string;
  page: number;
  pageSize: number;
  sortOptions?: SortOption[];
  isDescending?: boolean;
  sort?: string;
  filters?: SearchFilterFacet[];
  numericFilters?: FiltersRangeDto;
  dateTimeFilters?: DateTimeFilter[];
}

export async function searchInterventionReportsCommand({
  page,
  pageSize,
  sortOptions = [],
  sort,
  isDescending,
  query,
  filters = [],
  numericFilters = [],
  dateTimeFilters = [],
}: SearchInterventionReportsCommandPayload): Promise<
  | BackResponse<SearchResultList<InterventionReportSummary>>
  | BackResponseFailure
> {
  try {
    return await apiCall<
      BackResponse<SearchResultList<InterventionReportSummary>>
    >(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        page,
        pageSize,
        sortOptions,
        sort,
        isDescending,
        query,
        filters,
        numericFilters,
        dateTimeFilters,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
